import React, {
    Fragment,
    useEffect,
    useState
} from 'react';
import {Col, FormControl, Row} from 'react-bootstrap';

import {service as OrganizationService} from "../../../Services/OrganizationService";
import {service as RelationshipService} from "../../../Services/RelationshipService";
import {service as ContactService} from "../../../Services/ContactService";
import {usePrimeCache} from "../../../Hooks/ServiceHooks";
import {useUpdateTableFilters} from "../../../Hooks/TableHooks";

const initialFilters = [
    
];

export const ContactsTableFilter = (props) => {
    
    const {
        Data,
        Filters,
        UpdateFilters: updateFilters = (filters) => {},
        filterValues = {},
        setFilterValue,
    } = props;
    
    const {
        organizationId = '',
        relationshipId = '',
        textFilter = '',
    } = filterValues;
    
    const textFilterUppercase = textFilter?.toUpperCase?.();
    
    const filters = [
        {
            code: 'organizationId',
            isSet: organizationId !== "",
            logic: (x) => Number(x.organizationId) === Number(organizationId)
        },
        {
            code: 'relationshipId',
            isSet: relationshipId !== "",
            logic: (x) => {
                if(x?.ProjectStakeholderRelationship?.length) {
                    return x.ProjectStakeholderRelationship
                        .some(y => Number(y.relationshipId) === Number(relationshipId));
                }
                return false;
            }
        },
        {
            code: 'textFilter',
            isSet: textFilterUppercase !== "",
            logic: (x) => {
                const contactName = ContactService.GetTitle(x);
                return (
                    contactName?.toUpperCase().includes(textFilterUppercase) ||
                    x?.StakeholderAddresses?.Address?.phone?.toUpperCase().includes(textFilterUppercase) ||
                    x?.StakeholderAddresses?.Address?.email?.toUpperCase().includes(textFilterUppercase)
                );
            }
        }
    ];

    useUpdateTableFilters(filters, updateFilters, [relationshipId, organizationId, textFilter]);
    
    usePrimeCache([RelationshipService, OrganizationService]);
    
    const relationships = RelationshipService.CachedValues()?.result ?? [];
    const organizations = OrganizationService.CachedValues()?.result ?? [];
    
    const usedOrganizationIds = Data?.map(
        item => item?.organizationId
    ) ?? [];
    
    const usedRelationshipIds = Data?.flatMap(
        item => item?.ProjectStakeholderRelationship?.map(rel => rel?.relationshipId) ?? []
    ) ?? [];

    return <Fragment>
        <Col lg={4} sm={4} xs={12} />
        <Col lg={8} sm={8} xs={12}>
             <Row>
                 <Col xs={4} className="d-flex align-items-center">
                     {organizations.length > 1 ?
                     <FormControl
                         style={{width: '100%'}}
                         as="select"
                         placeholder={organizationId === "" ? "Select an Organization" : "Remove Filter"}
                         value={organizationId}
                         onChange={event => setFilterValue('organizationId', event.target.value)}
                     >
                         <option value="" key="">{organizationId === "" ? "Select an Organization" : "Remove Filter"}</option>
                        {organizations
                            .filter(org => usedOrganizationIds.includes(org.organizationId))
                            .map((org) =>
                            <option key={org.organizationId} value={org.organizationId}>{org.name}</option>
                        )}
                     </FormControl>
                     : null }
                 </Col>
                 <Col xs={4} className="d-flex align-items-center">
                     <FormControl
                         style={{width: '100%'}}
                         as="select"
                         placeholder={relationshipId === "" ? "Select A Filter": "Remove Filter"}
                         value={relationshipId}
                         onChange={event => setFilterValue('relationshipId', event.target.value)}
                     >
                         <option value="" key="">{relationshipId === "" ? "Select A Filter": "Remove Filter"}</option>
                        {relationships
                            .filter(rel => usedRelationshipIds.includes(rel.relationshipId))
                            .map(rel =>
                                <option key={rel.relationshipId} value={rel.relationshipId}>{rel.name}</option>
                            )}
                     </FormControl>
                 </Col>
                 <Col xs={4} className="d-flex align-items-center">
                     <FormControl
                         style={{width: '100%'}}
                         type="text"
                         autoCorrect="off"
                         autoCapitalize="off"
                         autoComplete="off"
                         spellCheck={false}
                         value={textFilter}
                         placeholder="Search Contacts"
                         onChange={event => setFilterValue('textFilter', event.target.value)}
                     />
                 </Col>
             </Row>
             <Row />
        </Col>
    </Fragment>;
}
